import CrudRepository from './CrudRepository'
export default class FeatureControllerRepository extends CrudRepository {
  constructor () {
    super('core/api/featureController/all')
  }
}
